import { format } from "date-fns";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { getDownloadQualityReportCSVDetails, getQualityAssuranceWoundAssessmentWorklist } from "../../../app/woundReportSlice";
import { DASHBOAD_QUALITY_ASSURANCE_ASSESSMENT, LIST_VIEW_LIMIT } from "../../../constants";
import Spreadsheet from "../../../static/images/ExportSpredsheet.svg";
import { DataTable, Pagination } from "../../secondary";
import style from "./qualityReportData.module.scss";
import { useHistory } from "react-router-dom";
import { Button } from "../../primary";
import Loader from "../../../static/images/spinner.svg";

export const QualityReportData = ({ woundProgressValue, tempPayload, selectedDivOption }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const woundAssessmentData = useSelector((state) => state.woundreport.qualityAssuranceAssessmentData);
  const qualityReportCsv = useSelector((state) => state.woundreport.qualityReportCsv);
  const isQualityReportCsvLoading = useSelector((state) => state.woundreport.isQualityReportCsvLoading);
  const isQualityAssuranceLoading = useSelector((state) => state.woundreport.isQualityAssuranceLoading);

  const [activePage, setActivePage] = useState(1);
  const [offSet, setOffSet] = useState(0);
  const [sortType, setSortType] = useState("");
  const csvLink = useRef(null);

  useEffect(() => {
    setSortType("");
    setOffSet(0);
    setActivePage(1);
    const woundAssessmentPayload = {
      ...tempPayload,
      section: selectedDivOption,
      subsection: woundProgressValue,
    };
    const listPayLoad = {};
    listPayLoad["url"] = DASHBOAD_QUALITY_ASSURANCE_ASSESSMENT;
    listPayLoad["method"] = "Post";
    listPayLoad["payload"] = woundAssessmentPayload;
    listPayLoad["queryParam"] = { offSet: 0, limit: LIST_VIEW_LIMIT };
    if (woundAssessmentPayload && woundAssessmentPayload.facility && woundAssessmentPayload.facility.length > 0) {
      dispatch(getQualityAssuranceWoundAssessmentWorklist(listPayLoad));
    }
  }, [tempPayload, selectedDivOption]);

  const getFileName = () => {
    const csvDownloadDate = format(new Date(), "MM-dd-yyyy");
    return `NE1-Quality-Assurance-Report-${csvDownloadDate}.csv`;
  };

  const columns = [
    {
      Header: "Wound number",
      accessor: "woundNumber",
      restWidth: "150px",
    },
    {
      Header: "Photo taken by",
      accessor: "photoTakenBy",
      restWidth: "180px",
    },
    {
      Header: "Photo taken on",
      accessor: "photoTakenOn",
      restWidth: "200px",
    },
    {
      Header: "MRN #",
      accessor: "mrn",
      restWidth: "100px",
    },
    {
      Header: "Patient's name",
      accessor: "patientName",
      restWidth: "180px",
    },
    {
      Header: "History/Cause",
      accessor: "historyCause",
      restWidth: "200px",
    },
    {
      Header: "Anatomy",
      accessor: "anatomy",
      restWidth: "200px",
    },
    {
      Header: "Last assessed",
      accessor: "lastAccessed",
      restWidth: "200px",
    },
    {
      Header: "Admission date",
      accessor: "admissionDate",
      restWidth: "200px",
    },
    {
      Header: "Signed by",
      accessor: "signedBy",
      restWidth: "200px",
    },
    {
      Header: "Reviewed by",
      accessor: "reviewedBy",
      restWidth: "200px",
    },
  ];

  const getSelectedRowData = (data) => {
    if (data) {
      history.push(`/${"patients"}/${data.ne1Id}/${"assessment"}/${data.woundId}`);
    }
  };

  const deleteDataList = () => {};

  const selectRowCount = () => {};

  const handleSort = useCallback(
    (data) => {
      if (data && data.sortBy[0] && data.sortBy[0].id) {
        const woundAssessmentPayload = {
          ...tempPayload,
          section: selectedDivOption,
          subsection: woundProgressValue,
        };
        const sortingColumn = data.sortBy[0];
        const sortingType = sortingColumn ? (sortingColumn.desc ? ":DESC" : ":ASC") : "";
        let sortParam = sortingColumn.id + sortingType;
        const listPayLoad = {};
        listPayLoad["url"] = DASHBOAD_QUALITY_ASSURANCE_ASSESSMENT;
        listPayLoad["method"] = "Post";
        listPayLoad["payload"] = woundAssessmentPayload;
        listPayLoad["queryParam"] = {
          offSet: isNaN(offSet) === true ? 0 : offSet,
          limit: LIST_VIEW_LIMIT,
          sort: sortParam,
        };
        setSortType(sortParam);
        if (woundAssessmentPayload && woundAssessmentPayload.facility && woundAssessmentPayload.facility.length > 0) {
          dispatch(getQualityAssuranceWoundAssessmentWorklist(listPayLoad));
        }
      }
    },
    [dispatch, tempPayload, selectedDivOption]
  );
  const getActivePage = (data) => {
    setActivePage(data);
    const woundAssessmentPayload = {
      ...tempPayload,
      section: selectedDivOption,
      subsection: woundProgressValue,
    };
    const listPayLoad = {};
    listPayLoad["url"] = DASHBOAD_QUALITY_ASSURANCE_ASSESSMENT;
    listPayLoad["method"] = "Post";
    listPayLoad["payload"] = woundAssessmentPayload;
    listPayLoad["queryParam"] = {
      limit: LIST_VIEW_LIMIT,
      offSet: data * LIST_VIEW_LIMIT - LIST_VIEW_LIMIT < LIST_VIEW_LIMIT ? 0 : data * LIST_VIEW_LIMIT - LIST_VIEW_LIMIT,
      sort: sortType ? sortType : "",
    };
    setOffSet(data * LIST_VIEW_LIMIT - LIST_VIEW_LIMIT < LIST_VIEW_LIMIT ? 0 : data * LIST_VIEW_LIMIT - LIST_VIEW_LIMIT);
    if (woundAssessmentPayload && woundAssessmentPayload.facility && woundAssessmentPayload.facility.length > 0) {
      dispatch(getQualityAssuranceWoundAssessmentWorklist(listPayLoad));
    }
  };

  const fileHeaders = [
    { label: "Wound Number", key: "woundNumber" },
    { label: "MRN #", key: "mrn" },
    { label: "Patient's Name", key: "patientName" },
    { label: "Photo Taken By", key: "photoTakenBy" },
    { label: "Photo Taken On", key: "photoTakenOn" },
    { label: "History/Cause", key: "historyCause" },
    { label: "Anatomy", key: "anatomy" },
    { label: "Last Assessed", key: "lastAccessed" },
    { label: "Admission Date", key: "admissionDate" },
    { label: "Signed By", key: "signedBy" },
    { label: "Reviewed By", key: "reviewedBy" },
  ];

  const handleDownloadCSV = async () => {
    const total = woundAssessmentData?.metadata?.total ?? 0;
    if (!total) return;

    const queryParam = `limit=${total}&offSet=0`;

    const payload = {
      ...tempPayload,
      section: selectedDivOption,
      subsection: woundProgressValue,
    };

    if (!payload?.facility?.length) return;

    await dispatch(getDownloadQualityReportCSVDetails(payload, queryParam));

    setTimeout(() => {
      csvLink.current?.link?.click();
    }, 0);
  };

  return (
    <>
      {qualityReportCsv?.woundAssessment && qualityReportCsv?.woundAssessment.length > 0 && (
        <>
          <div className="col-sm-12 mb-2 justify-content-end d-flex">
            <span className={style.down_spread}>
              <Button type="button" className={style.download_btn} onClick={handleDownloadCSV}>
                {isQualityReportCsvLoading ? (
                  <img src={Loader} alt="loading" style={{ width: "2rem", height: "2rem", paddingBottom: "4px" }} />
                ) : (
                  <img src={Spreadsheet} alt="" />
                )}{" "}
                Download as CSV
              </Button>
              <CSVLink
                headers={fileHeaders}
                data={qualityReportCsv?.woundAssessment || []}
                filename={getFileName()}
                target="_blank"
                ref={csvLink}
                style={{ display: "none" }}
              />
            </span>
          </div>
        </>
      )}
      {isQualityAssuranceLoading ? (
        <div className="loader">
          <img src={Loader} alt="loading" />
        </div>
      ) : (
        <div className="col-12">
          <DataTable
            columns={columns}
            data={woundAssessmentData?.woundAssessment ?? []}
            sorting={true}
            getSelectedRowData={getSelectedRowData}
            setSelectedRows={selectRowCount}
            onSort={handleSort}
            detailView={true}
            deleteDataList={deleteDataList}
            showFixedColumn={false}
            workListView={true}
            reportView={true}
            sortType={sortType ? sortType : ""}
          />
        </div>
      )}

      {!isQualityAssuranceLoading && Array.isArray(woundAssessmentData.woundAssessment) && woundAssessmentData.woundAssessment.length > 1 && (
        <Pagination
          activePage={activePage}
          itemsCountPerPage={woundAssessmentData?.metadata ? woundAssessmentData?.metadata?.limit : 50}
          totalItemsCount={woundAssessmentData?.metadata ? woundAssessmentData?.metadata?.total : 0}
          getActivePage={getActivePage}
          reportView={true}
        />
      )}
    </>
  );
};
